export class IssueItemViewModel {
    // #region Properties

    public rddV2Id: string = "";
    public categoryName: string = "";
    public rddV2s: any[] = [];

    // #endregion Properties
}
